/**
 * Exception for loading timeout
 *
 * @access public
 */
class LoadingTimeoutError extends Error {
  constructor() {
    super("SEON SDK loading timed out");
    /**
     * @constant
     * @type {"LoadingTimeoutError"}
     */

    this.name = "LoadingTimeoutError";
  }

}

export { LoadingTimeoutError };
